
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { maxLength, required } from 'vuelidate/lib/validators';
import type { Validation } from 'vuelidate';
import { validationMixin } from 'vuelidate';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import BravadoIconButton from '~/components/common/BravadoIconButton/BravadoIconButton.vue';
import { validateNumberInput } from '~/components/utils/keys';

export default Vue.extend({
  name: 'PublicPortfolioEditAward',
  components: {
    BravadoIconButton,
    BravadoTextInputV3,
    IconTrash: () => import('@/components/Icon/Trash.vue'),
  },
  mixins: [validationMixin],
  props: {
    year: {
      type: [Number, String],
      default: 2021,
    } as PropOptions<number | string>,
    name: {
      type: String,
      required: true,
    } as PropOptions<string>,
    touched: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  validations: {
    year: { required },
    name: { required, maxLength: maxLength(80) },
  },
  computed: {
    isYearValid(): boolean {
      return !(this.touched && (this.$v.year as Validation).$invalid);
    },
    isNameValid(): boolean {
      const nameValidation = this.$v.name as Validation;
      // @ts-ignore Property 'maxLength' does not exist on type 'Validation'
      return nameValidation.maxLength || !(this.touched && nameValidation.$invalid);
    },
  },
  methods: {
    onYearKeydown(event: KeyboardEvent) {
      validateNumberInput(event);
    },
  },
});
